module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate18.5d94ab9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate18.png
// module id = 753
// module chunks = 0